
/// <amd-module name="Release/Commands/CreateNewFolderService" />
import * as React from "react";

import { Services, VssService, IVssService } from "VSS/Platform/Context";
import { IMenuItem } from "VSSUI/Menu";
import { IVssLayoutManager, WrappedComponent, IWrappedComponentProperties } from "VSS/Platform/Layout";

import { hasRmPermissions, ReleaseManagementSecurityPermissions } from "Release/Helpers/Permission";
import { IReleaseDefinitionPivotCommandContext } from "Release/Client/ExtensionContracts/IMenuCommandContracts";
import { IFolderDetailsDialogProps } from "./DialogTypes";
import * as Resources from "Release/Commands/Resources";

export const newFolderAction: (context: IReleaseDefinitionPivotCommandContext, createFolderCallback?: (path: string) => any, parentButtonId?: string) => IMenuItem | undefined = (context: IReleaseDefinitionPivotCommandContext, createFolderCallback?: (path: string) => any, parentButtonId?: string) => {
    if (hasRmPermissions(context.pageContext, context.folderPath, context.pipelineId, ReleaseManagementSecurityPermissions.EditReleaseDefinition)) {
        return {
            id: "create-folder-command",
            text: Resources.NewFolderCommand,
            iconProps: { iconName: "Add" },
            onActivate: () => {
                context.pageContext.getService<ICreateFolderService>("ICreateFolderService").createFolder(context, createFolderCallback, parentButtonId);
            }
        };
    }
};

export interface ICreateFolderService extends IVssService {
    createFolder(context: IReleaseDefinitionPivotCommandContext, createFolderCallback: any, parentButtonId?: string): void;
}

class CreateFolderService extends VssService implements ICreateFolderService {
    public createFolder(context: IReleaseDefinitionPivotCommandContext, createFolderCallback: any, parentButtonId?: string): void {
        const layoutManager = context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");

        layoutManager.renderCallout((onDismiss) => {
            const props: IFolderDetailsDialogProps & IWrappedComponentProperties = {
                wrappedType: "release-folder-dialog",
                dependencies: ["ms.vss-releaseManagement-web.release-command-dialogs"],
                title: Resources.NewFolderDialogTitle,
                parentPath: context.folderPath,
                parentButtonId: parentButtonId,
                onClose: onDismiss,
                onFolderUpdated: (newFolderPath: string) => {
                    createFolderCallback(newFolderPath);
                    // context.successCallback(`Folder created with path: ${newFolderPath}`);
                }
            };

            return React.createElement(WrappedComponent, props);
        });
    }
}

Services.add("ICreateFolderService", { serviceFactory: CreateFolderService });
